import {
  ButtonProps,
  ButtonType,
  Img,
  InteractionState} from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { ShareContentButtonStyles } from '../../content/styles/ShareContentButtonStyles';

export interface ShareContentButtonProps {
        readonly handleClick: () => void;
        readonly testId: string;
        readonly text?: string;
    }
const shareIconImgSrc = (state: InteractionState) => {
    let imgName = '';
    if(state.disabled) {
        imgName = 'share_disabled.svg';
    } else if(state.active || state.hover || state.selected) {
        imgName = 'share_active.svg';
    } else {
        imgName = 'share.svg';
    }
    return imgPath(imgName);
};

const fillColorFor = (state: InteractionState): string => {
    if(state.disabled) {
        return '#bfbfbf';
    } else if(state.active || state.hover || state.selected) {
        return '#333';
    } else {
        return '#666';
    }
};

const ToolbarShareIcon = (interactiveState: InteractionState) => <Img
    draggable={false}
    src={shareIconImgSrc(interactiveState)}
    style={{ opacity: interactiveState.disabled ? 0.35 : 1 }}
    />;

export function ShareContentButton(props: ShareContentButtonProps): ButtonProps {
    return {
        buttonType: ButtonType.LowEmphasis,
        getContent: (state: InteractionState) => <div className={ShareContentButtonStyles.root}>
            {ToolbarShareIcon(state)}
            <div
                className={ShareContentButtonStyles.text}
                style={{color: fillColorFor(state)}}
            >
                {props.text}
            </div>
        </div>,
        title: Messages.shareContentButtonTitle(),
        handleClick: props.handleClick,
        testId: props.testId,
    };
}
